
import { createReducer, on } from '@ngrx/store';
import * as UserActions from '../actions/user.actions';
import { AppUserState } from '../states/app.state';


export const initialCurrentUserState: AppUserState = {
  sub: '',
  name: '',
  lastName: '',
  role: '',
  roleName: '',
  image: null,
};

export const currentUserReducer = createReducer(
  initialCurrentUserState,
  on(UserActions.setCurrentUser, (state, { currentUser }) => currentUser),
  on(UserActions.clearCurrentUser, () => initialCurrentUserState)
);
